<script setup lang="ts">

import { Badge } from "@/components/ui/badge";

type MaintenanceRecordStatus = {
  value:  'planned' | 'in_progress' | 'done' | 'blocked',
  label: string,
}
const props = defineProps<{
  status: MaintenanceRecordStatus,
}>()

const variantsByStatus = {
  planned: 'zinc',
  in_progress: 'yellow',
  done: 'green',
  blocked: 'red',
} as const
</script>

<template>
  <Badge :variant="variantsByStatus[props.status.value]">
    {{ props.status.label }}
  </Badge>
</template>
